if (!customElements.get('ih-load-more-products')) {
  customElements.define('ih-load-more-products', class extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector('[data-load-more-button]');
      if (!this.button) return;

      const initialUrl = new URL(this.button.href, location.origin);
      if (initialUrl.searchParams.has('section_id')) {
        initialUrl.searchParams.delete('section_id');
        this.button.href = initialUrl.toString();
      }

      this.button.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.abortController?.abort();
      if (!this.button) return;
      this.button.removeEventListener('click', this.onClick);
      this.setLoading(false);
    }

    onClick(event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (this.loading) return;
      this.setLoading(true);

      const url = new URL(this.button.href, location.origin);
      url.searchParams.set('section_id', this.dataset.sectionId);

      this.abortController = new AbortController();

      fetch(url, { signal: this.abortController.signal })
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((text) => this.renderResponse(text))
        .catch((error) => {
          if (error.name === 'AbortError') return;
          const fallbackUrl = new URL(this.button.href, location.origin);
          fallbackUrl.searchParams.delete('section_id');
          location.href = fallbackUrl;
        });
    }

    setLoading(loading) {
      this.loading = loading;
      this.button.classList.toggle('loading', loading);
      this.button.setAttribute('aria-busy', loading);
      const spinner = this.button.querySelector('.loading__spinner');
      if (spinner) spinner.classList.toggle('hidden', !loading);
    }

    renderResponse(text) {
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const grid = document.getElementById('product-grid');
      if (!grid) {
        this.setLoading(false);
        return;
      }

      const existingIds = new Set(Array.from(grid.children).map((li) => li.dataset.productId));
      const newItems = Array.from(doc.querySelectorAll('#product-grid > li')).filter(
        (li) => !existingIds.has(li.dataset.productId)
      );
      newItems.forEach((li) => grid.appendChild(li));

      const nextEl = doc.querySelector('ih-load-more-products');
      const countEl = this.querySelector('[data-load-more-count]');
      const nextCount = nextEl?.querySelector('[data-load-more-count]');
      if (countEl && nextCount) countEl.textContent = nextCount.textContent;

      const nextButton = nextEl?.querySelector('[data-load-more-button]');
      if (nextButton) {
        const nextUrl = new URL(nextButton.getAttribute('href'), location.origin);
        nextUrl.searchParams.delete('section_id');
        this.button.href = nextUrl.toString();
        this.setLoading(false);
      } else {
        this.button.remove();
        this.button = null;
      }

      this.moveFocus(newItems, countEl);
      this.announce(countEl?.textContent);
    }

    moveFocus(items, countEl) {
      let target = null;
      if (items.length) {
        const li = items[0];
        target =
          li.querySelector('h3 a') ||
          Array.from(li.querySelectorAll('a, button')).find(
            (el) => el.tabIndex !== -1 && el.getAttribute('aria-hidden') !== 'true' && !el.disabled
          );
      }
      if (!target && !this.button && countEl) {
        countEl.setAttribute('tabindex', '-1');
        target = countEl;
      }
      if (target) target.focus();
    }

    announce(message) {
      const status = document.getElementById(`LoadMoreStatus-${this.dataset.sectionId}`);
      if (!status || !message) return;
      status.textContent = '';
      setTimeout(() => {
        status.textContent = message;
      }, 100);
    }
  });
}
